import axios from "axios";
import { NavigateFunction } from "react-router-dom";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";
import i18next from "i18next";

export interface Figure {
  value: number;
  prev: number;
}
export interface SiteStats {
  websiteId: string;
  dashboardUrl: string;
  figures: { visitors: Figure; visits: Figure; pageviews: Figure; bounceRate: Figure; avgVisitSeconds: Figure };
  days: { day: string; visitors: number; pageviews: number }[];
  top: Record<"url" | "browser" | "device" | "country", { name: string; count: number }[]>;
}
export interface Stats {
  configured: boolean;
  ok?: boolean;
  message?: string;
  hours?: number;
  unit?: "hour" | "day";
  sites?: Partial<Record<"tenant" | "player", SiteStats>>;
}

/** admin → Statistik: figures from Umami, read by the backend */
export const getStats = async (hours: number, isMobile: boolean, navigate: NavigateFunction): Promise<Stats | null> => {
  try {
    const response = await axios.get(`${baseURL}/v1/stats`, {
      headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` },
      params: { hours },
    });
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      showErrorToast(i18next.t("messages.sessionExpired"), isMobile);
      localStorage.removeItem("access_token");
      navigate("/");
    } else {
      showErrorToast(error?.response?.data?.message || "Could not load the statistics", isMobile);
    }
    return null;
  }
};
